import { Component, Input, OnInit, ViewEncapsulation, ViewChild, ViewContainerRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogRef, DialogService, DialogsModule, DialogResult } from '@progress/kendo-angular-dialog';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID, GridSize, GridModule } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { saveIcon, editToolsIcon, plusIcon, uploadIcon } from '@progress/kendo-svg-icons';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule, TextBoxComponent } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { FormControl, FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { process } from '@progress/kendo-data-query';
import { SVGIcon, xIcon, gearIcon, fileExcelIcon, changeManuallyIcon, copyIcon, questionCircleIcon } from '@progress/kendo-svg-icons';
import { Companies, emptyCompanies, Users } from '../../../_models/admin';
import { PortalAdminService } from '../../../_services/portal-admin.service';
import { KENDO_NOTIFICATION, NotificationService } from "@progress/kendo-angular-notification";
import { SheetDescriptor, SpreadsheetComponent, SpreadsheetMainMenuItem, SpreadsheetModule } from '@progress/kendo-angular-spreadsheet';
import { ExcelModule } from '@progress/kendo-angular-grid';

@Component({
    selector: 'app-companies',
    imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION,
        LayoutModule, CommonModule, DropDownListModule, InputsModule, LabelModule, FormsModule,
        ReactiveFormsModule, DialogsModule, SpreadsheetModule, GridModule, ExcelModule
    ],
    templateUrl: './companies.component.html',
    styleUrl: './companies.component.css',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompaniesComponent implements OnInit {
  adminCompanies: Companies[] = [];
  adminCompany!: Companies;
  displayCompanies: Companies[] = [];
  selection: any[] = [];
  companiesLoading: boolean = false;
  openedexcelwindow: boolean = false;
  buttonshidden: boolean = false;
  addbuttonstate: boolean = false;
  removebuttonstate: boolean = true;
  savebuttonstate: boolean = true;
  readonly: boolean = false;
  searchTerm: string = '';
  selectedRowItem: any[] = [];
  pageSize: number = 30;
  excelSVG: SVGIcon = fileExcelIcon;
  uploadbuttonstate: boolean = false;
  public items: SpreadsheetMainMenuItem[] = [{ id: "file", active: true }];
  public iconNames: SVGIcon[] = [plusIcon, xIcon, saveIcon, gearIcon, editToolsIcon, copyIcon, changeManuallyIcon, questionCircleIcon, uploadIcon];
  @ViewChild('spreadsheet') spreadsheet1!: SpreadsheetComponent;
  uploadCompanies: Companies[] = [];
  headerValidation: boolean = false;
  public smallSize: GridSize = 'small';
  windowTitle: string = 'Portal Company(s) Load';
  errorWindow = false;
  title = '';
  content = '';
  exceldata: SheetDescriptor[] = [
    {
      name: "Company",
      rows: [
        {
          cells: [
            {
              value: "Company Name",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Address",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "City",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "State",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Zip",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Phone",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Recipient Code",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            }
          ],
        },
        {
          cells: [{ value: "McDermott", enable: true },
          { value: "Prinseslaan 1", enable: true },
          { value: "Den Haag", enable: true },
          { value: "Zuid-Holland", enable: true },
          { value: "1234AB", enable: true },
          { value: "+31-1234", enable: true },
          { value: "MCD", enable: true }],

        },
        {
          cells: [{ value: "New Company", enable: true },
          { value: "-", enable: true },
          { value: "-", enable: true },
          { value: "-", enable: true },
          { value: "-", enable: true },
          { value: "-", enable: true },
          { value: "-", enable: true }],

        },
      ],
      columns: [
        { index: 0, width: 140 },
        { index: 1, width: 130 },
        { index: 2, width: 170 },
        { index: 3, width: 170 },
        { index: 4, width: 170 },
        { index: 5, width: 170 },
        { index: 6, width: 170 },
      ],
    },
  ];
  private dialogs: DialogRef[] = [];
  uploadCompany: Companies = emptyCompanies();
  error!: string;
  adminUsers: Users[] = [];
  adminUser!: Users;
  showErrorDialog: boolean = false;
  errorMessage: string = '';
  public form: FormGroup = new FormGroup({
    companyId: new FormControl(),
    companyName: new FormControl(),
    address: new FormControl(),

    recipientCode: new FormControl(),
    city: new FormControl(),
    state: new FormControl(),
    country: new FormControl(),
    zip: new FormControl(),
    phone: new FormControl(),
  });

  constructor(
    private dialogService: DialogService,
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private portalAdminService: PortalAdminService,
    private cdr: ChangeDetectorRef,
    private viewContainerRef: ViewContainerRef
  ) { }

  ngOnInit(): void {
    this.getAdminCompanies();
    this.buildattributeform();
  }

  getAdminCompanies() {
    this.companiesLoading = true;
    this.adminCompanies = [];
    this.form.reset();
    this.portalAdminService.getCompanies().subscribe({
      next: (result) => {
        this.adminCompanies = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.log(error)
        this.showError(JSON.stringify(error.message));
        this.companiesLoading = false;
      },
      complete: () => {
        this.displayCompanies = this.adminCompanies;
        this.companiesLoading = false;
        this.selection = this.selectedRowItem;
        this.form.disable();
      }
    });
  }


  public onFilter(inputValue: string): void {
    this.searchTerm = inputValue;
    this.form.reset();
    this.selection = [];
    this.form.disable();
    this.buttonhandle('Filter');
    
    this.displayCompanies = process(this.adminCompanies, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'companyName',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'recipientCode',
            operator: 'contains',
            value: inputValue,
          },
        ],
      },
    }).data;


  }
  buildattributeform() {
    this.form = this.formBuilder.group({
      companyId: [{ value: '', disabled: true }],
      companyName: ['', [Validators.required, Validators.minLength(3)]],
      address: [''],
      city: [''],
      state: [''],
      zip: [''],
      phone: [''],
      recipientCode: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  @Input() item = '';

  @ViewChild('companyname') companyName!: TextBoxComponent;

  onAddButtonClick() {
    this.form.reset();
    this.form.enable();
    this.form.get('companyId')?.disable(); // keep ID disabled
    this.selection = [];
    this.buttonhandle('Add');
    this.initialFormValues = this.form.getRawValue();

    setTimeout(() => {
      this.companyName.focus();
    }, 100);
  }

  onRemoveButtonClick() {
    const popupErrorMessages = [
      'Cannot delete company: it is still used in orders.'
    ];
    this.selectedRowItem = [];
    this.removebuttonstate = true;
    this.portalAdminService.deleteCompanies(this.form.get('companyId')?.value).subscribe({
      next: (result) => {
        this.adminCompany = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        const backendMessage = error?.error?.message || 'An unexpected error occurred.';

        if (popupErrorMessages.includes(backendMessage)) {
          this.errorMessage = backendMessage;
          this.showErrorDialog = true;
          this.cdr.markForCheck();
        } else {
          this.showErrorDialog = false;
          this.showError(backendMessage); // Show as red error
        }

        this.companiesLoading = false;
      },
      complete: () => {
        this.selection = [];
        this.getAdminCompanies();
      }
    });
  }
  @ViewChild("appendTo", { read: ViewContainerRef, static: false })
  public appendTo!: ViewContainerRef;

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }
  public success(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 3000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "success", icon: true },
    });
  }

  onSaveButtonClick() {

    this.selectedRowItem = [];
    this.buttonhandle('Save');

    if (this.form.get('companyId')?.value == null) {
      this.portalAdminService.addCompanies(this.form.value).subscribe({
        next: (result) => {
          this.adminCompany = result;

          this.cdr.markForCheck();
          this.companiesLoading = true;
        },
        error: (error) => {
          //throw message of some sort
          //this.showError(JSON.stringify(error.message));
          console.log("this.form.value",this.form.value)
          if (error.status == 409) {
            this.error = '';
            const i = this.adminCompanies.findIndex((x) => x.companyName === this.form.value.companyName);
            if (i != -1) {
              this.error = 'Company already in Database: ' + this.form.value.companyName + '\n';

            }
            const j = this.adminCompanies.findIndex((x) => x.recipientCode === this.form.value.recipientCode);

            if (j != -1) {
              this.error = this.error + 'Recipient Code already in Database: ' + this.form.value.recipientCode + '\n';
            }
            
            if (this.error.length > 0) {
              this.errorWindow = true;
              this.title = 'Error(s) - Creating Company';
              this.content = this.error;
              this.cdr.markForCheck();
            }
          } else {
            this.showError(JSON.stringify(error.message));
          }

          this.companiesLoading = false;
        },
        complete: () => {
          this.selectedRowItem = [this.adminCompany.companyId];
          this.getAdminCompanies();
        }
      });
    } else {
      this.portalAdminService.updateCompanies(this.form.get('companyId')?.value, this.form.value).subscribe({
        next: (result) => {
          this.adminCompany = result;
          this.cdr.markForCheck();
        },
        error: (error) => {
          
          if (error.status == 409) {
            this.error = '';
            const i = this.adminCompanies.findIndex((x) => x.companyName === this.form.value.companyName);
            if (i != -1) {
              this.error = 'Company already in Database: ' + this.form.value.companyName + '\n';
            }
            const j = this.adminCompanies.findIndex((x) => x.recipientCode === this.form.value.recipientCode);

            if (j != -1) {
              this.error = this.error + 'Recipient Code already in Database: ' + this.form.value.recipientCode + '\n';
            }

            if (this.error.length > 0) {
              this.errorWindow = true;
              this.title = 'Error(s) - Updating Company';
              this.content = this.error;
            }
            this.cdr.markForCheck();
          } else {
            this.showError(JSON.stringify(error.message));
          }

          //this.showError(JSON.stringify(error.message));
          this.companiesLoading = false;
        },
        complete: () => {
          this.selectedRowItem = [this.adminCompany.companyId];
          this.getAdminCompanies();
        }
      });
    }
    this.uploadbuttonstate = false;
  }

  buttonhandle(action: string) {
    this.addbuttonstate = true;
    this.removebuttonstate = true;
    this.savebuttonstate = true;
    this.uploadbuttonstate = true;
    if (action === 'Click') {
      this.addbuttonstate = false;
      this.removebuttonstate = false;
    }
    if (action === 'Filter') {
      this.addbuttonstate = false;

    }
    if (action === 'Save') {
      this.addbuttonstate = false;

    }
    if (action === 'Upload') {
      this.uploadbuttonstate = true;
      this.addbuttonstate = false;
    }
  }
  initialFormValues!: Companies;
  onCellClick(event: any) {
    this.form.reset();
    this.form.patchValue({
      companyId: event.dataItem.companyId,
      companyName: event.dataItem.companyName,
      address: event.dataItem.address,
      city: event.dataItem.city,
      recipientCode: event.dataItem.recipientCode,
      state: event.dataItem.state,
      zip: event.dataItem.zip,
      phone: event.dataItem.phone
    });
    this.form.get('companyId')?.disable(); // keep ID disabled
    this.initialFormValues = this.form.getRawValue();
    this.readonly = false;
    this.buttonhandle('Click');
    this.form.enable(); // enables all except disabled ones
    this.uploadbuttonstate = false;
  }

  valueChange(event: any) {
    this.formHasChanged();
  }
  formHasChanged(): boolean {
    const checkvalue = Object.entries(this.initialFormValues).some(
      ([field, value]) => value !== this.form.getRawValue()[field]
    );
    const company = this.form.get('companyName')?.value;
    const recipientCode = this.form.get('recipientCode')?.value;
    this.savebuttonstate = checkvalue && company && company.length > 2 && recipientCode && recipientCode.length > 2 ? false : true;
    return checkvalue;
  }


  onExcelClick() {
    this.buttonhandle('Upload');
    this.uploadbuttonstate = true;
    this.addbuttonstate = true;
    this.openedexcelwindow = true;
  }
  closeExcelWindow() {
    this.openedexcelwindow = false;
    this.uploadbuttonstate = false;
    this.addbuttonstate = false;
    this.dialogs = [];
  }
  openedExcelwindow() {
    this.openedexcelwindow = true;
    setTimeout(() => {
      this.spreadsheet1.onMenuItemSelect("file");
    });
  }


  onExcelExport(e: any): void {
    e.workbook.sheets[0].rows = this.displayCompanies.map(item => ({
      cells: [
        { value: item.companyId },
        { value: item.companyName },
        { value: item.address },
        { value: item.city },
        { value: item.state },
        { value: item.zip },
        { value: item.phone },
        { value: item.recipientCode },
      ]
    }));
    e.workbook.sheets[0].rows.unshift({
      cells: [
        { value: 'ID', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'Company Name', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'Address', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'City', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'State', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'Zip', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'Phone', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
        { value: 'Recipient Code', background: 'rgb(128, 128, 128)', color: '#FFFFFF', bold: true },
      ]
    });
    e.workbook.sheets[0].columns = [
      { autoWidth: true },
      { autoWidth: true },
      { autoWidth: true },
      { autoWidth: true },
      { autoWidth: true },
      { autoWidth: true },
      { autoWidth: true }
    ];
  }


  saveExcelSample(spreadsheet: SpreadsheetComponent): void {
    const data = spreadsheet.spreadsheetWidget.toJSON();
    this.uploadCompanies = [];
    const sheet = data.sheets;
    const rows = sheet![0].rows || [];
    this.error = '';
    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].cells || [];

      if (i === 0) {
        this.headerValidation = this.validateHeader(rows[i]);
        if (!this.headerValidation) {
          this.error = 'Header validation failed.\n';
          break;
        }
        continue;
      }

      while (cells.length < 7) {
        cells.push({ value: '' });
      }

      const isEmptyRow = cells.every(cell => {
        const val = cell?.value?.toString().trim();
        return !val || val === '';
      });

      if (isEmptyRow) continue;

      let filledCount = 0;
      for (let j = 0; j < 7; j++) {
        const val = cells[j]?.value?.toString().trim();
        if (val && (val !== '')) {
          filledCount++;
        }
      }

      if (filledCount < 7) {
        this.error += `Row ${i}: not all fields have values (fieldcount ${filledCount})\n`;
        continue;
      }

      this.uploadCompany = emptyCompanies();
      for (let j = 0; j < 7; j++) {
        const rawValue = cells[j]?.value?.toString().trim();
        const value = rawValue && rawValue !== '' ? rawValue : '-';
        this.validateUpload(value, j);
      }

      this.uploadCompanies.push(this.uploadCompany);
    }

    this.uploadCompanies = this.uploadCompanies.filter(c => c.companyName !== '');

    const nameSet = new Set<string>();
    const codeSet = new Set<string>();

    for (const company of this.uploadCompanies) {
      const { companyName, recipientCode } = company;

      if (nameSet.has(companyName)) {
        this.error += `Multiple entries found for Company Name: ${companyName}\n`;
      } else {
        nameSet.add(companyName);
      }

      if (recipientCode && recipientCode !== '-' && recipientCode.trim() !== '') {
        if (codeSet.has(recipientCode)) {
          this.error += `Multiple entries found for Recipient Code: ${recipientCode}\n`;
        } else {
          codeSet.add(recipientCode);
        }
      }
    }

    if (this.error.length > 0) {
      this.errorWindow = true;
      this.title = 'Error(s) - Company(s) Upload';
      this.content = this.error;
    } else {
      const companyCount = this.uploadCompanies.length;
      const dialog: DialogRef = this.dialogService.open({
        title: 'Confirmation - Company(s) Upload',
        content: `${companyCount} Company(s) will be uploaded`,
        actions: [{ text: 'Cancel' }, { text: 'Save' }],
        width: 450,
        height: 200,
        minWidth: 250
      });

      dialog.result.subscribe((result: any) => {
        if (result.text === 'Cancel') {
          dialog.close();
        }
        if (result.text === 'Save') {
          let companiesAdded = 0;
          for (const company of this.uploadCompanies) {
            this.portalAdminService.addCompanies(company).subscribe(res => {
              if (++companiesAdded === this.uploadCompanies.length) {
                this.getAdminCompanies();
              }
            });
          }
          this.closeExcelWindow();
        }
      });
    }
  }

  public get formattedErrorText(): string {
    return this.content
      .split('\n')
      .map(line =>
        line
          .split(':')
          .map(part => part.trim())
          .join('\t')
      )
      .join('\n');
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.formattedErrorText).then(() => {
      console.log('Copied to clipboard');
    });
  }
  validateHeader(value: any): boolean {
    let checkvalue: boolean = true;
    if (value.cells![0].value!.valueOf().toLocaleString().toUpperCase() != 'COMPANY NAME') {
      checkvalue = false;
    }
    if (value.cells![1].value!.valueOf().toLocaleString().toUpperCase() != 'ADDRESS') {
      checkvalue = false;
    }
    if (value.cells![2].value!.valueOf().toLocaleString().toUpperCase() != 'CITY') {
      checkvalue = false;
    }
    if (value.cells![3].value!.valueOf().toLocaleString().toUpperCase() != 'STATE') {
      checkvalue = false;
    }
    if (value.cells![4].value!.valueOf().toLocaleString().toUpperCase() != 'ZIP') {
      checkvalue = false;
    }
    if (value.cells![5].value!.valueOf().toLocaleString().toUpperCase() != 'PHONE') {
      checkvalue = false;
    }
    if (value.cells![6].value!.valueOf().toLocaleString().toUpperCase() != 'RECIPIENT CODE') {
      checkvalue = false;
    }


    if (!checkvalue) {
      this.error = 'Wrong Temoplate Header. must contain [Company Name,	Address, City, State, Zip, Phone, RECIPIENT Code] \n'
    }
    return checkvalue;
  }
  validateUpload(value: string, field: number) {
    if (field == 0) {
      const i = this.adminCompanies.findIndex((x) => x.companyName === value);
      if (i != -1) {
        this.error = this.error + 'Company already in Database: ' + value + '\n';

      }
      else {
        this.uploadCompany.companyName = value;
      }
    }
    if (field == 1 && value != '-') {
      this.uploadCompany.address = value;
    }
    if (field == 2 && value != '-') {
      this.uploadCompany.city = value;
    }
    if (field == 3 && value != '-') {
      this.uploadCompany.state = value;
    }
    if (field == 4 && value != '-') {
      this.uploadCompany.zip = value;
    }
    if (field == 5 && value != '-') {
      this.uploadCompany.phone = value;
    }
    if (field == 6 && value != '-') {
      const i = this.adminCompanies.findIndex((x) => x.recipientCode === value);

      if (i != -1) {
        this.error = this.error + 'Recipient Code already in Database: ' + value + '\n';
      }
      else {
        this.uploadCompany.recipientCode = value;
      }
    }
  }
  addUser(userdata: Users) {
    this.portalAdminService.addUsers(userdata).subscribe({
      next: (result) => {
        this.adminUser = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        this.showError(JSON.stringify(error.message));
        this.companiesLoading = false;
      },
      complete: () => {
        this.getAdminCompanies();
        this.selection = [];
      }
    });
  }
  getFileName() {
    let str = 'Portal Companies';
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
}
